import { getAlmeSessionData } from '../../AlmeApp/AlmeAppSessionState';
import { TerminateLiveChat } from "../../LiveChat/AlmeLiveChatReportingEvents";
function createRCUserLoginParams(sessionId, accountNumber, emailId, primaryName, zipCode, accountType) {
    return {
        ClientSessionId: sessionId,
        UserObj: {
            accountNumber,
            emailId,
            primaryName,
            zipCode,
            accountType: accountType,
        },
        IsLoggedIn: true,
    };
}
function createPeaksUserLoginParams(sessionId, platformInformation, currentEnterpriseId) {
    return {
        ClientSessionId: sessionId,
        UserObj: {
            platformInformation,
            currentEnterpriseId,
        },
        IsLoggedIn: true,
    };
}
function createCCTRLoginParams(sessionId, accountId, emailId) {
    return {
        ClientSessionId: sessionId,
        UserObj: {
            accountId,
            emailId,
        },
        IsLoggedIn: true,
    };
}
function createVistaUserLoginParams(sessionId, platformInformation, platform, currentEnterpriseId) {
    return {
        ClientSessionId: sessionId,
        UserObj: {
            platformInformation,
            platform,
            currentEnterpriseId,
        },
        IsLoggedIn: true,
    };
}
function createLogoutParams(clientSessionId) {
    return {
        ClientSessionId: clientSessionId,
        IsLoggedIn: false,
        LaunchPointName: 'Logout',
        LaunchParameter: 'Logout',
        LaunchType: 'Manual',
        NewSessionReason: 'newSessionOnLogout',
    };
}
async function logoutEvent(almeApiUtils, clientSessionId) {
    var _a;
    await almeApiUtils.sendAppEvent("OnUserLogOut", undefined, {
        ClientSessionId: clientSessionId,
        IsLoggedIn: false,
    });
    await almeApiUtils.endConversation();
    almeApiUtils.createNewSessionData();
    await almeApiUtils.sendAppEvent('HostPageData', undefined, {
        PageInfo: window._SFDDL,
        AlmeUserID_PreLogin: (_a = getAlmeSessionData()) === null || _a === void 0 ? void 0 : _a.userId,
    });
    return await almeApiUtils.sendAppEvent("WelcomeUser", undefined, createLogoutParams(clientSessionId));
}
export function getAccountId(almeState, sessionId, accountId) {
    if (almeState.sessionMessages
        && almeState.sessionMessages.sessionId
        && (almeState.sessionMessages.sessionId === sessionId)
        && almeState.sessionMessages.messages
        && almeState.sessionMessages.messages.SwitchAccount) {
        return almeState.sessionMessages.messages.SwitchAccount.accountId;
    }
    return accountId;
}
const updateRcOrBnplUserLoggedInState = async (almeState, appConfig, almeApiUtils, userLogInState) => {
    const hasPreviousConversation = almeState.hasPreviousConversation;
    if (appConfig.main.isLoggedIn) {
        if (!almeState.isLoggedIn || !hasPreviousConversation) {
            const userMetadata = appConfig.main.userMetadata;
            const accountNumber = userMetadata === null || userMetadata === void 0 ? void 0 : userMetadata.accountNumber;
            const emailId = userMetadata === null || userMetadata === void 0 ? void 0 : userMetadata.emailId;
            const primaryName = userMetadata === null || userMetadata === void 0 ? void 0 : userMetadata.primaryName;
            const zipCode = userMetadata === null || userMetadata === void 0 ? void 0 : userMetadata.zipCode;
            const accountType = userMetadata === null || userMetadata === void 0 ? void 0 : userMetadata.accountType;
            userLogInState.isLoggedIn = true;
            userLogInState.loginStateResponse = await almeApiUtils.sendAppEvent("OnUserLogIn", undefined, createRCUserLoginParams(userLogInState.clientSessionId, accountNumber, emailId, primaryName, zipCode, accountType));
        }
    }
    else {
        if (hasPreviousConversation && almeState.isLoggedIn) {
            await TerminateLiveChat(almeApiUtils, almeState);
            userLogInState.isLiveChatConnected = false;
            userLogInState.loginStateResponse = await logoutEvent(almeApiUtils, userLogInState.clientSessionId);
        }
        userLogInState.isLoggedIn = false;
    }
};
const updatePsccUserLoggedInState = async (almeState, appConfig, almeApiUtils, userLogInState) => {
    const hasPreviousConversation = almeState.hasPreviousConversation;
    if (appConfig.main.isLoggedIn) {
        if (!hasPreviousConversation || !almeState.isLoggedIn) {
            const userMetadata = appConfig.main.userMetadata;
            const accountId = getAccountId(almeState, userLogInState.clientSessionId, userMetadata === null || userMetadata === void 0 ? void 0 : userMetadata.accountId);
            const emailId = userMetadata === null || userMetadata === void 0 ? void 0 : userMetadata.emailId;
            userLogInState.isLoggedIn = true;
            userLogInState.loginStateResponse = await almeApiUtils.sendAppEvent("OnUserLogIn", undefined, createCCTRLoginParams(userLogInState.clientSessionId, accountId, emailId));
        }
    }
    else {
        if (hasPreviousConversation && almeState.isLoggedIn) {
            await TerminateLiveChat(almeApiUtils, almeState);
            userLogInState.isLiveChatConnected = false;
            userLogInState.loginStateResponse = await logoutEvent(almeApiUtils, userLogInState.clientSessionId);
        }
        userLogInState.isLoggedIn = false;
    }
};
const updateVistaUserLoggedInState = async (almeState, appConfig, almeApiUtils, userLogInState) => {
    const hasPreviousConversation = almeState.hasPreviousConversation;
    if (appConfig.main.isLoggedIn) {
        if (!almeState.isLoggedIn || !hasPreviousConversation) {
            const userMetadata = appConfig.main.userMetadata;
            const platform = appConfig.main.platform;
            const currentEnterpriseId = almeState.currentEnterpriseId || (userMetadata === null || userMetadata === void 0 ? void 0 : userMetadata.currentEnterpriseId);
            let platformInformation = userMetadata === null || userMetadata === void 0 ? void 0 : userMetadata.platformInformation;
            // Different versions of browsers were getting this as an object instead of an Array. 
            // so explicitly checking this because FPML needs this as an array
            if (platformInformation instanceof Object) {
                platformInformation = Object.values(platformInformation);
            }
            userLogInState.isLoggedIn = true;
            userLogInState.loginStateResponse = await almeApiUtils.sendAppEvent("OnUserLogIn", undefined, createVistaUserLoginParams(userLogInState.clientSessionId, platformInformation, platform === null || platform === void 0 ? void 0 : platform.toString(), currentEnterpriseId));
        }
    }
    else {
        if (hasPreviousConversation && almeState.isLoggedIn) {
            await TerminateLiveChat(almeApiUtils, almeState);
            userLogInState.isLiveChatConnected = false;
            userLogInState.loginStateResponse = await logoutEvent(almeApiUtils, userLogInState.clientSessionId);
        }
        userLogInState.isLoggedIn = false;
    }
};
const updatePeaksUserLoggedInState = async (almeState, appConfig, almeApiUtils, userLogInState) => {
    const hasPreviousConversation = almeState.hasPreviousConversation;
    if (appConfig.main.isLoggedIn) {
        if (!almeState.isLoggedIn || !hasPreviousConversation) {
            const userMetadata = appConfig.main.userMetadata;
            const currentEnterpriseId = almeState.currentEnterpriseId || (userMetadata === null || userMetadata === void 0 ? void 0 : userMetadata.currentEnterpriseId);
            let platformInformation = userMetadata === null || userMetadata === void 0 ? void 0 : userMetadata.platformInformation;
            // Different versions of browsers were getting this as an object instead of an Array. 
            // so explicitly checking this because FPML needs this as an array
            if (platformInformation instanceof Object) {
                platformInformation = Object.values(platformInformation);
            }
            userLogInState.isLoggedIn = true;
            userLogInState.loginStateResponse = await almeApiUtils.sendAppEvent("OnUserLogIn", undefined, createPeaksUserLoginParams(userLogInState.clientSessionId, platformInformation, currentEnterpriseId));
        }
    }
    else {
        if (hasPreviousConversation && almeState.isLoggedIn) {
            await TerminateLiveChat(almeApiUtils, almeState);
            userLogInState.isLiveChatConnected = false;
            userLogInState.loginStateResponse = await logoutEvent(almeApiUtils, userLogInState.clientSessionId);
        }
        userLogInState.isLoggedIn = false;
    }
};
/**
 * @param almeApiUtils API utility
 * @param almeState App state
 * @returns User logged in state and response
 */
export async function sendLoginStateEvents(appConfig, almeApiUtils, almeState) {
    const userLogInState = { isLoggedIn: almeState.isLoggedIn, isLiveChatConnected: almeState.isLiveChatConnected };
    if (appConfig.main.platform === "RC" || appConfig.main.platform === "BNPL" || appConfig.main.platform === "universal-idp") {
        userLogInState.clientSessionId = appConfig.main.clientSessionId;
        await updateRcOrBnplUserLoggedInState(almeState, appConfig, almeApiUtils, userLogInState);
    }
    else if (appConfig.main.platform === "PSCC") {
        userLogInState.clientSessionId = appConfig.main.clientSessionId;
        await updatePsccUserLoggedInState(almeState, appConfig, almeApiUtils, userLogInState);
    }
    else if (appConfig.main.platform === "VISTA") {
        userLogInState.clientSessionId = appConfig.main.clientSessionId;
        await updateVistaUserLoggedInState(almeState, appConfig, almeApiUtils, userLogInState);
    }
    else if (appConfig.main.platform === "PEAKS") {
        userLogInState.clientSessionId = appConfig.main.clientSessionId;
        await updatePeaksUserLoggedInState(almeState, appConfig, almeApiUtils, userLogInState);
    }
    return userLogInState;
}
